import React from "react";

export default function ViewSurveyModal({ contact, onClose }) {
  return (
    <div className="SurvayModalOverlay">
      <div className="SurvayModalContentOuter">
        <div className="modalHeader">
          <h5 className="m-0">Survey contact</h5>

          <button onClick={onClose} className="CloseIcon">
            Close
          </button>
        </div>

        <div className="SurvayModalContent">
          <div className="modalBody">
            <p>
              <strong>Company name:</strong> {contact?.companyName || "--"}
            </p>

            <p>
              <strong>Full name:</strong> {contact?.fullName || "--"}
            </p>

            <p>
              <strong>Email:</strong> {contact?.email || "--"}
            </p>

            <p>
              <strong>Phone number:</strong> {contact?.phoneNumber || "--"}
            </p>

            <p>
              <strong>Message:</strong> {contact?.message || "--"}
            </p>

            <p>
              <strong>Created at:</strong>{" "}
              {contact?.createdAt
                ? new Date(contact.createdAt).toLocaleDateString()
                : "--"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
